import { Routes } from '@angular/router';
import { protectedGuards } from '../../core/auth/auth.guard';
import { restaurantAdminGuard } from './data-access/restaurant-admin.guard';

export const restaurantShellRoutes: Routes = [
  {
    path: 'restaurant',
    loadComponent: () =>
      import('./pages/restaurant-overview/restaurant-overview').then(
        (module) => module.RestaurantOverview,
      ),
    data: { titleKey: 'routes.restaurant' },
  },
];

export const restaurantRoutes: Routes = [
  {
    path: 'dish/:id',
    canActivate: protectedGuards,
    loadComponent: () =>
      import('./pages/dish-detail/dish-detail').then((module) => module.DishDetail),
    data: { titleKey: 'routes.dishDetail' },
  },
  {
    path: 'restaurant-admin/orders',
    canActivate: [...protectedGuards, restaurantAdminGuard],
    loadComponent: () =>
      import('./pages/admin-orders/admin-orders').then((module) => module.AdminOrders),
    data: { titleKey: 'routes.adminOrders' },
  },
  {
    path: 'restaurant-admin/orders/:id',
    canActivate: [...protectedGuards, restaurantAdminGuard],
    loadComponent: () =>
      import('./pages/admin-orders/admin-orders').then((module) => module.AdminOrders),
    data: { titleKey: 'routes.adminOrderBuyers' },
  },
];
